import React from 'react';
import PropTypes from 'prop-types';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import Transition from 'react-transition-group/Transition';
import cx from 'classnames';

/**
 * TransitionList
 * @param props
 * @returns {*}
 * @constructor
 */
export const TransitionList = (props) => {

  const { children, exitTimeout, className } = props;

  if (!children.length) {
    return null;
  }

  const transitionTimeout = {
    // Set 'enter' timeout to '0' so that enter animation
    // will start immediately.
    enter: 0,

    // Set 'exit' timeout to transition duration + delay so that the 'exited'
    // status won't be applied until animation completes.
    exit: exitTimeout,
  };

  return (
    <TransitionGroup>
      {
        React.Children.map(children, (child) => {
          return (
            <Transition timeout={transitionTimeout} key={child.key}>
              {(status) => {
                // Children is a function that receives the current
                // status of the animation.

                // Don't render anything if component has 'exited'.
                if (status === 'exited') {
                  return null;
                }
                return React.cloneElement(child, { className: cx(child.props.className, `${className}__transition-animation--${status}`) });
              }}
            </Transition>
          );
        })
      }
    </TransitionGroup>
  );
};

TransitionList.displayName = 'TransitionList';

TransitionList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  exitTimeout: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
};

export default TransitionList;
